import { cn } from "@/lib/utils";
import { STATUS_COLORS } from "@/lib/nav";

export default function StatusBadge({ status, className }) {
    if (!status) return null;
    const cls = STATUS_COLORS[status] || "bg-muted text-foreground border-border";
    return (
        <span
            data-testid={`status-badge-${status}`}
            className={cn(
                "inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md border text-[10.5px] uppercase tracking-[0.08em] font-medium",
                cls,
                className
            )}
        >
            <span className="w-1 h-1 rounded-full bg-current opacity-70" />
            {status}
        </span>
    );
}
